export default {
  informazioniLegali: 'Legal information',
  companyDetails:
    '© 1994–{year} Pixartprinting S.p.A. single shareholder<br />Subject to the management and coordination of Cimpress plc - VAT IT04061550275 - All rights reserved.',
  posizioniAperte: 'Explore our vacancies',
  entraNelNostroTeam: 'Join our<br> team!',
  entraNelTeam: 'Join the team',
  scopri: 'Learn more',

  // Links
  infoLegaliLink: 'https://www.pixartprinting.com/legal-information/',
  privacyLink: 'https://www.pixartprinting.com/privacy/',
  cookieLink: 'https://www.pixartprinting.com/cookie-policy/',
  recruitingLink:
    'https://inrecruiting.intervieweb.it/pixartprinting/en/career',
}
